/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Andrey Tkachenko <andrey.tkachenko@opensoftdev.ru>
 */

define(['underscore', 'assets/js/common/router/index', 'assets/js/modules/AjaxOperation'], function(_, router, AjaxOperation) {
    var API_QUANTITY = '/api/v0/pricing/options-quantity/{productName}';
    var API_SAVE_HASH = '/api/v0/pricing/get-options-quantity-hash/{productName}';
    var API_GET_SHIPPING_PRICES = '/api/v0/pricing_shipping';

    return {
        items: function() {
            return new AjaxOperation(
                { name: 'Load Pricing' },
                {
                    type: 'get',

                    url: function() {
                        return router.generate(API_QUANTITY, { productName: this.getObject().product });
                    },

                    data: function() {
                        return _.pick(this.getObject(), 'options', 'discountCode', 'numOfSides');
                    },

                    ajaxSuccess: function(data) {
                        if (typeof data == 'object' && data.items) {
                            this.setFinished(AjaxOperation.SUCCESS, data.items);
                        } else {
                            this.setFinished(AjaxOperation.ERROR);
                        }
                    }
                }
            );
        },

        savePricingOptions: function() {
            return new AjaxOperation(
                { name: 'Save Pricing Options in Session' },
                {
                    type: 'get',

                    dataType: 'json',

                    url: function() {
                        return router.generate(API_SAVE_HASH, { productName: this.getObject().productType });
                    }
                }
            );
        },

        getShippingPrices: function(params) {
            return new AjaxOperation(
                { name: 'Get Shipping Prices' },
                {
                    type: 'get',

                    dataType: 'json',

                    url: router.generate(API_GET_SHIPPING_PRICES),

                    data: params
                }
            );
        }
    };
});
